import Component from 'vue-loading-overlay';
import { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
    // {
    //     name: 'Root',
    //     path: '/',
    //     component: () => import('../layouts/NavLayout.vue'),
    //     children: [
    //         {
    //             name: 'Dashboard',
    //             path: '/dashboard',
    //             meta: {auth: true, title: '仪表盘'},
    //             component: () => import('../pages/IndexPage.vue'),
    //         },
    //     ]
    // },
    {
        name: 'Dashboard',
        path: '/dashboard',
        meta: {auth: true, title: '仪表盘'},
        component: () => import('../pages/IndexPage.vue'),
    },
    {
        name: 'Signin',
        path: '/signin',
        meta: {auth: false},
        props: function (route) {
            return {
                token: route.query.token as string,
            }
        },
        component: () => import('../pages/SigninPage.vue'),
    },
    {
        name: 'Error404',
        path: '/404',
        meta: {auth: false},
        component: () => import('../pages/Error404Page.vue'),
    },
    {
        path: '/:pathMatch(.*)',
        meta: {auth: false},
        redirect: {name: 'Error404'},
    }
];

export default routes;
